import { ChangeDetectorRef, Component, Input, ViewChild, ElementRef } from '@angular/core';

import type { User } from '@recruitee/account-types';
import type { Attachment } from '@recruitee/attachments-types';
import { trackByProp } from '@recruitee/common';
import { I18nService, TranslatePipe } from '@recruitee/i18n';
import {
  AttachmentItemComponent,
  AvatarComponent,
  BoxComponent,
  ButtonComponent,
  DateComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-approval-request-message-box',
  templateUrl: './approval-request-message-box.component.html',
  styleUrls: ['./approval-request-message-box.component.less'],
  imports: [
    AttachmentItemComponent,
    AvatarComponent,
    BoxComponent,
    ButtonComponent,
    DateComponent,
    HeadingComponent,
    IconComponent,
    RtTooltip,
    TranslatePipe,
  ],
})
export class ApprovalRequestMessageBoxComponent {
  public readonly COLLAPSED_MESSAGE_MAX_HEIGHT = 72; // 3 * @line-height

  @Input() public requester: User | null;
  @Input() public attachments: Attachment[];
  @Input() public bodyHtml: string | null;
  @Input() public createdAt: string;

  public messageCollapsed: boolean = true;
  public hasExpandButton: boolean;

  public trackById = trackByProp<{ id: number }>({ prop: 'id' });

  @ViewChild('requestMessageText') private requestMessageText: ElementRef;

  constructor(
    private i18n: I18nService,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngAfterViewInit(): void {
    if (this.bodyHtml) {
      this.hasExpandButton =
        this.requestMessageText.nativeElement.scrollHeight > this.COLLAPSED_MESSAGE_MAX_HEIGHT;
      this.cdRef.detectChanges();
    }
  }

  public get requesterFullName(): string {
    if (!this.requester) return this.i18n.translate('app.requisitions.flow.deleted_user');

    const { firstName, lastName } = this.requester;
    return `${firstName} ${lastName}`;
  }

  public toggleShowMore(): void {
    this.messageCollapsed = !this.messageCollapsed;
    this.cdRef.detectChanges();
  }
}
